import { DeviceForListFragment } from '@/shared/types/types.generated';

type TLinkedGateway = DeviceForListFragment['linkedGateways']['items'][number];

// Generic over the gateway shape so each caller keeps the fields its own device
// fragment selected; the list fragment carries only id, name and the primary flag.
export const useLinkedGatewaysForDevice = <
  TGateway extends TLinkedGateway,
>(device?: {
  linkedGateways: { items: TGateway[] };
}) => {
  const linkedGateways: TGateway[] = device?.linkedGateways.items ?? [];
  const primaryGateway =
    linkedGateways.find((gateway) => gateway.linkMetaData?.primary) ??
    linkedGateways[0];

  return {
    linkedGateways,
    primaryGateway,
  };
};
